import React, {Component} from 'react';

import axios from 'axios';
import config from "../../config";

import Loader from "../Loader";

class AdditionalContent extends Component {

  state = {
    content: false
  };

  componentWillMount() {

    axios.get(`${config.apiBase}/additional-content/`)
      .then(response => {

        this.setState({
          content: response.data
        });

        const {Flatsome} = window;

        if (Flatsome !== undefined) {
          Flatsome.attach(document.querySelector('.footer .additional-content'));
        }

      });

  }

  render() {
    return (
      <div className="additional-content">
        {this.state.content !== false
          ?
          <div
            className="lightbox" // Flatsome features classes
            dangerouslySetInnerHTML={{__html: this.state.content}}
          />
          :
          <Loader/>
        }

      </div>
    );
  }
}


export default AdditionalContent;
